import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/store'

import Home from '../views/Home.vue'

const Eligibility = () => import('../views/beneficiaire/Eligibility')
const BeneficiaireRegister = () => import('../views/beneficiaire/BeneficiaireRegister')
const Login = () => import('../views/Login')
const PasswordReset = () => import('../views/settings/PasswordReset')
const PasswordResetConfirm = () => import('../views/settings/PasswordResetConfirm')

// ---------- USER CONNECTED ------------------------
const Logout = () => import('../views/Logout')
const ModifyPassword = () => import('../views/settings/ModifyPassword')

// ---------- BENEFICIAIRE CONNECTED ----------------
const BeneficiaireProfileEdition = () => import('../views/beneficiaire/BeneficiaireProfileEdition')
const BeneficiaireDashboard = () => import('../views/beneficiaire/BeneficiaireDashboard')
const BourseDetails = () => import('../views/beneficiaire/BourseDetails')

// ---------- CONSEILLER CONNECTED ----------------
const ConseillerDashboard = () => import('../views/conseiller/ConseillerDashboard')
const ConseillerBourseProfile = () => import('../views/conseiller/ConseillerBourseProfile')
const ConseillerBeneficiaireDashboard = () => import('../views/conseiller/ConseillerBeneficiaireDashboard')

// ---------- GLOBAL ---------
const notFound = () => import('../views/notFound')
const ConditionsAttribution = () => import('../views/ConditionsAttribution')
const Help = () => import('../views/Help')
const DetailledHelp = () => import('../views/DetailledHelp')
const FAQ = () => import('../views/FAQ')

const ConfidentialityPolitique = () => import('../views/information/ConfidentialityPolitique')
const MentionsLegales = () => import('../views/information/MentionsLegales')
const ConditionsUtilisation = () => import('../views/information/ConditionsUtilisation')



Vue.use(VueRouter)

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}


const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}


const isUserGroup = (group_name) => {
  var userGroups = store.getters.getUserGroups
  var userGroupsArray = []
  var is_contained = false
  if (userGroups) {
    try {
      var userGroupsJson = JSON.parse(userGroups)
      for (var i = 0; i < userGroupsJson.length; i++) {
        userGroupsArray.push(
          userGroupsJson[i]['name']
        )
      }
    }
    catch(error) {
      return is_contained
    }
  }

  for (var j = 0; j < group_name.length; j++) {
    if (userGroupsArray.indexOf(group_name[j]) > -1) {
      is_contained = true
    }
  }
  return is_contained
}

const isConnectedBeneficiaire = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (isUserGroup(['BENEFICIAIRE'])) {
      next()
      return
    }
    else {
      next('/')
    }
  }
  else {
    next('/login')
  }
}


const isConnectedConseiller = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    if (isUserGroup(['CONSEILLER'])) {
      next()
      return
    }
    else {
      next('/')
    }
  }
  else {
    next('/login')
  }
}


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/eligibilite',
    name: 'Eligibility',
    component: Eligibility,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/creation-compte',
    name: 'BeneficiaireRegister',
    component: BeneficiaireRegister,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/settings/reset-password',
    name: 'PasswordReset',
    component: PasswordReset,
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/settings/reset-password-confirm',
    name: 'PasswordResetConfirm',
    component: PasswordResetConfirm,
    beforeEnter: ifNotAuthenticated
  },

  // ----------- USER CONNECTED ----------------
  {
    path: '/settings/modify-password',
    name: 'ModifyPassword',
    component: ModifyPassword,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: ifAuthenticated
  },

  // ----------- BENEFICIAIRE CONNECTED --------
  {
    path: '/settings/profile-edition',
    name: 'BeneficiaireProfileEdition',
    component: BeneficiaireProfileEdition,
    beforeEnter: isConnectedBeneficiaire
  },
  {
    path: '/beneficiaire-dashboard',
    name: 'BeneficiaireDashboard',
    component: BeneficiaireDashboard,
    beforeEnter: isConnectedBeneficiaire
  },
  {
    path: '/bourse/:bourse_id',
    name: 'BourseDetails',
    component: BourseDetails,
    beforeEnter: isConnectedBeneficiaire
  },

  // ------------ CONSEILLER CONNECTED ----------
  {
    path: '/conseiller-dashboard',
    name: 'ConseillerDashboard',
    component: ConseillerDashboard,
    beforeEnter: isConnectedConseiller
  },
  {
    path: '/conseiller-dashboard/bourse/:bourse_id',
    name: 'ConseillerBourseProfile',
    component: ConseillerBourseProfile,
    beforeEnter: isConnectedConseiller
  },
  {
    path: '/conseiller-dashboard/beneficiaire/:beneficiaire_id',
    name: 'ConseillerBeneficiaireDashboard',
    component: ConseillerBeneficiaireDashboard,
    beforeEnter: isConnectedConseiller
  },

  // ------------ ALL ----------------
  {
    path: '/404',
    name: 'notFound',
    component: notFound,
  },
  {
    path: '/aide',
    name: 'Help',
    component: Help,
  },
  {
    path: '/aide-detaillee',
    name: 'DetailledHelp',
    component: DetailledHelp,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
  },
  {
    path: '/conditions-attribution',
    name: 'ConditionsAttribution',
    component: ConditionsAttribution,
  },
  {
    path: '/politique-de-confidentialite',
    name: 'ConfidentialityPolitiqueHelp',
    component: ConfidentialityPolitique,
  },
  {
    path: '/mentions-legales',
    name: 'MentionsLegales',
    component: MentionsLegales,
  },
  {
    path: '/conditions-utilisations',
    name: 'ConditionsUtilisation',
    component: ConditionsUtilisation,
  },
  {
    path: '*',
    redirect: '/404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
